// extracted by mini-css-extract-plugin
export default {"container":"WithdrawStarsModal_container__D0wcG","votingInput":"WithdrawStarsModal_votingInput__yTEf3","maxButton":"WithdrawStarsModal_maxButton__qjZpA"};